import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Navbar from './nav.js';
import One from './img-sec-1.js';
import Two from './img-sec-2.js';
import Three from './img-sec-3.js';
import Abc from './sec-4.js'; 




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <div>
    <Navbar></Navbar>
    <One></One>
    <Two></Two>
    <Three></Three>
    <Abc> </Abc>
    
    
    
    
    
  </div>
  
);

